export default "__VITE_ASSET__DZZ2oGKL__"